import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CardActivationComponent } from './card-activation.component';
import { LoginComponent } from './components/login/login.component';
import { MemberTypeComponent } from './components/member-type/member-type.component';
import { MemberUpdateComponent } from './components/member-update/member-update.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { SdcModule } from '../sdc/sdc.module';
import { ActivationHttpInterceptor } from './interceptors/activation-http.interceptor';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { HelpFAQComponent } from './components/help-faq/help-faq.component';
import { HelpFaqContentComponent } from './components/help-faq-content/help-faq-content.component';
import { RedirectionHandlerComponent } from './components/redirection-handler/redirection-handler.component';

const cardActivationRoutes: Routes = [
  {
    path: '',
    component: CardActivationComponent, // RootComponent will be the default route
  },
  {
    path: 'nz-link-callback',
    component: RedirectionHandlerComponent
  }
];

@NgModule({
  declarations: [
    CardActivationComponent,
    LoginComponent,
    MemberTypeComponent,
    MemberUpdateComponent,
    ConfirmationComponent,
    SetPasswordComponent,
    HelpFAQComponent,
    HelpFaqContentComponent,
    RedirectionHandlerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(cardActivationRoutes),
    FlexLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    MatExpansionModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    SdcModule,
    MatButtonModule,
    MatStepperModule,
    MatDividerModule
  ],
  providers: [
    {
      provide: Window,
      useValue: window
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
  ],
})
export class CardActivationModule {}
